<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <h3 class="title">Thống kê đề xuất</h3>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="d-flex">
        <mat-card class="report-card flex-grow-1" style="width: 50%;">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Số request theo hành động</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center" *ngIf="barChartRendering">
                    <div class="pinner">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div style="display: block" *ngIf="!barChartRendering">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptions"
                        [legend]="barChartLegend"
                        [colors]="barChartColors"
                        [chartType]="barChartType">
                    </canvas>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="report-card flex-grow-1" style="width: 50%;">
            <mat-card-header class="one-card-header">
                <mat-card-title class="one-cart-title">Số request theo trạng thái</mat-card-title>
            </mat-card-header>
            <mat-card-content class="one-card-content">
                <div class="d-flex justify-content-center" *ngIf="pieChartRendering">
                    <div class="pinner">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
                <div style="display: block" *ngIf="!pieChartRendering">
                    <canvas baseChart
                        [data]="pieChartData"
                        [labels]="pieChartLabels"
                        [chartType]="pieChartType"
                        [options]="pieChartOptions"
                        [colors]="pieChartColors"
                        [legend]="pieChartLegend">
                    </canvas>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</mat-expansion-panel>